<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        bordered
        :dynamicColumnSetting="false"
        :needPage="false"
        :columns="columns"
        v-model:search="searchFrom"
        @fetch="fetch"
        ref="tableRef"
        tableId="lbuSalesWorkReport"
        id="lbuSalesWorkReport"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item label="维度">
              <a-radio-group v-model:value="searchFrom.queryType" optionType="button" :options="dimensionEnum" @change="search" />
            </dc-form-item>

            <dc-form-item label="区域">
              <CosStaticSelect
                :fieldNames="{ label: 'label', value: 'id' }"
                :options="deptInfo4List"
                mode="multiple"
                v-model:value="searchFrom.deptLevel4List"
              />
            </dc-form-item>
            <dc-form-item label="部门组织">
              <CosCascader
                placeholder="请选择"
                type="search"
                :options="deptInfo4List"
                :fieldNames="{ label: 'label', value: 'id', children: 'children' }"
                appId="cos_lbu"
                multiple
                v-model:ids="searchFrom.deptLevel5List"
              />
            </dc-form-item>
            <dc-form-item label="销售员">
              <UserSelect permission v-model:value="searchFrom.employeeNoList" mode="multiple" allowClear />
            </dc-form-item>
            <dc-form-item label="时间">
              <cos-range-picker v-model:startTime="searchFrom.startTime" v-model:endTime="searchFrom.endTime" />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button @click="exportRows" v-permission="'lbu_sales_work_export_btn'"> 导出 </a-button>
        </template>
        <template #bodyCell="{ column, text }">
          <template v-if="['transactionRatio', 'potentialRatio', 'clueRatio', 'saleChanceRate'].includes(column.dataIndex)">
            <p>{{ text === undefined || text === null ? '--' : (`${formatAmount(text, 2)}%`) }}</p>
          </template>
        </template>

      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { reactive, computed, ref, onMounted } from 'vue'
import { customerListFormat } from '@/utils'
import { LbuSalesWorkReportParams, salesWorkList } from '@/api/yuntuSales/salesWorkReport'
import { getDeptInfo } from '@/api/common'

import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import CosStaticSelect from '@/components/CosStaticSelect'
import dayjs from 'dayjs'
import { formatAmount } from '../../../utils/format'
const deptInfo4List = ref([])
// const deptInfo5List = ref([])

const tableRef = ref()
const searchFrom = reactive<LbuSalesWorkReportParams>({
  queryType: 1,
  startTime: dayjs().startOf('month').format('YYYY/MM/DD 00:00:00'),
  endTime: dayjs().endOf('month').format('YYYY/MM/DD 23:59:59')
})

const fetch = (searchFrom: LbuSalesWorkReportParams, callBack: (res: any) => void) => {
  const params = customerListFormat(searchFrom) // 处理客户名称和客户编码的批量查询参数
  salesWorkList(params).then((res) => {
    callBack(res)
  })
}

const search = () => {
  tableRef.value.search()
}

const fetchDeptInfo = async () => {
  const res = await getDeptInfo({ appId: 'cos_lbu', rootId: '3853844' })
  deptInfo4List.value = res.data?.deptInfo[0]?.children
  deptInfo4List.value.forEach((item: any) => {
    if (item.children && item.children.length) {
      item.children.forEach((o: any) => {
        if (o.children) delete o.children
      })
    }
  })
}

onMounted(() => {
  fetchDeptInfo()
})

const dimensionEnum = [
  { value: 1, label: '区域' },
  { value: 2, label: '组', color: '#EF8D3C', desc: '' },
  { value: 3, label: '销售员', color: '#3FAC46', desc: '' }
]

const columns = computed(() => {
  const columns = [
    {
      title: '',
      width: 450,
      children: [
        { title: '区域', fixed: 'left', dataIndex: 'deptLevel4Name', width: 100 },
        { title: '部门组织', fixed: 'left', dataIndex: 'deptLevel5Name', width: 100 },
        { title: '销售员', fixed: 'left', dataIndex: 'employeeName', width: 100 }
      ]
    },
    // { title: '区域', fixed: 'left', dataIndex: 'deptLevel4Name' },
    // { title: '部门组织', fixed: 'left', dataIndex: 'deptLevel5Name' },
    // { title: '销售员', fixed: 'left', dataIndex: 'employeeName' },
    {
      title: '拜访量',
      width: 780,
      children: [
        { title: '登门拜访量（负责人）', dataIndex: 'sellerVisits', width: 160 },
        { title: '登门拜访量（更新人）', dataIndex: 'updatedVisits', width: 160 },
        { title: '非登门拜访量', dataIndex: 'nonVisits', width: 120 },
        { title: '总拜访量', dataIndex: 'totalVisits', width: 80 },
        { title: '人均登门拜访量', dataIndex: 'avgVisits', width: 140 },
        { title: '人均总拜访量', dataIndex: 'avgTotalVisits', width: 120 }
      ]
    },
    {
      title: '拜访占比',
      width: 480,
      children: [
        { title: '拜访成交客户占比', dataIndex: 'transactionRatio', width: 160 },
        { title: '拜访潜在客户占比', dataIndex: 'potentialRatio', width: 160 },
        { title: '拜访线索客户占比', dataIndex: 'clueRatio', width: 160 }
      ]
    },

    {
      title: '商机管理（总数）',
      width: 840,
      children: [
        { title: '预计月销售额', dataIndex: 'planSaleAmount', width: 120 },
        { title: '达成合作月销售额', dataIndex: 'saleAmount', width: 160 },
        { title: '现有机会转化率', dataIndex: 'saleChanceRate', width: 140 },
        { title: '总机会个数', dataIndex: 'totalSaleChance', width: 100 },
        { title: '机会月销售额', dataIndex: 'opportunityMonthlySales', width: 120 },
        { title: '机会个数', dataIndex: 'numberSaleChance', width: 80 },
        { title: '人均机会金额', dataIndex: 'avgSaleAmount', width: 120 },
        { title: '人均机会个数', dataIndex: 'avgSaleChance', width: 120 }
      ]
    },
    {
      title: '商机管理（本期创建）',
      width: 220,
      children: [
        { title: '新增月销售额', dataIndex: 'newSaleAmount', width: 120 },
        { title: '新增机会数', dataIndex: 'newSaleChance', width: 100 }
      ]
    }
  ]
  if (searchFrom.queryType && searchFrom.queryType < 3) {
    columns[0].children.splice(2, 1)
    columns[0].width = columns[0].width - 100
  }

  if (searchFrom.queryType && searchFrom.queryType < 2) {
    columns[0].children.splice(1, 1)
    columns[0].width = columns[0].width - 100
  }

  return columns
})

const exportRows = () => {
  const et = XLSX.utils.table_to_book(document.querySelector('#lbuSalesWorkReport'))
  const etout = XLSX.write(et, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'array'
  })
  try {
    FileSaver.saveAs(
      new Blob([etout], {
        type: 'application/octet-stream'
      }),
      '销售工作情况表.xlsx'
    )
  } catch (e) {
    console.log(e, etout)
  }
  return etout
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuSalesWorkReport' }
</script>

<style scoped></style>
